/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserPaymentMethodRequestPaymentMethod
 */
export interface CreateUserPaymentMethodRequestPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof CreateUserPaymentMethodRequestPaymentMethod
     */
    stripePaymentMethodId: string;
}

/**
 * Check if a given object implements the CreateUserPaymentMethodRequestPaymentMethod interface.
 */
export function instanceOfCreateUserPaymentMethodRequestPaymentMethod(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stripePaymentMethodId" in value;

    return isInstance;
}

export function CreateUserPaymentMethodRequestPaymentMethodFromJSON(json: any): CreateUserPaymentMethodRequestPaymentMethod {
    return CreateUserPaymentMethodRequestPaymentMethodFromJSONTyped(json, false);
}

export function CreateUserPaymentMethodRequestPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserPaymentMethodRequestPaymentMethod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stripePaymentMethodId': json['stripe_payment_method_id'],
    };
}

export function CreateUserPaymentMethodRequestPaymentMethodToJSON(value?: CreateUserPaymentMethodRequestPaymentMethod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stripe_payment_method_id': value.stripePaymentMethodId,
    };
}

